import { Component, OnInit, Optional } from "@angular/core"; import { Location } from "@angular/common";
import { ItemService } from 'src/app/services/item-service';

@Component({
  selector: 'app-accessdenied',
  templateUrl: './app.accessdenied.component.html',
})
export class AppAccessdeniedComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }

  
}
